"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _grid = _interopRequireDefault(require("./grid"));

var _spacing = _interopRequireDefault(require("./spacing"));

var _mixins = require("../mixins");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    margin: 0 ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledContainer = (
/*#__PURE__*/
0, _styledBase["default"])('section', {
  target: "el9di6x0",
  label: "StyledContainer"
})(_grid["default"].grid, " ", _grid["default"].related, " margin:0 ", _spacing["default"].Medium, ";", _mixins.breakpoint.md(_templateObject(), _spacing["default"].Large), " @media only screen and (-ms-high-contrast:none){flex-direction:column;margin-bottom:", _spacing["default"].Large, ";> div:last-child{margin-bottom:0;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9MYXlvdXQvUmVsYXRlZENvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPeUMiLCJmaWxlIjoiLi4vLi4vc3JjL0xheW91dC9SZWxhdGVkQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgR3JpZCBmcm9tICcuL2dyaWQnO1xuaW1wb3J0IFNwYWNpbmcgZnJvbSAnLi9zcGFjaW5nJztcbmltcG9ydCB7IGJyZWFrcG9pbnQgfSBmcm9tICcuLi9taXhpbnMnO1xuXG5jb25zdCBTdHlsZWRDb250YWluZXIgPSBzdHlsZWQoJ3NlY3Rpb24nKWBcbiAgJHtHcmlkLmdyaWR9XG4gICR7R3JpZC5yZWxhdGVkfVxuXG4gIG1hcmdpbjogMCAke1NwYWNpbmcuTWVkaXVtfTtcblxuICAke2JyZWFrcG9pbnQubWRgXG4gICAgbWFyZ2luOiAwICR7U3BhY2luZy5MYXJnZX07XG4gIGB9XG5cbiAgQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAoLW1zLWhpZ2gtY29udHJhc3Q6IG5vbmUpIHtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIG1hcmdpbi1ib3R0b206ICR7U3BhY2luZy5MYXJnZX07XG5cbiAgICA+IGRpdjpsYXN0LWNoaWxkIHtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgICB9XG4gIH1cbmA7XG5cbi8qKiAvLyBDb250YWluZXIgQ29tcG9uZW50XG4gKiBpbXBvcnQgeyBMYXlvdXQgfSBmcm9tICdAa2JiY29tcG9uZW50bGlicmFyeS9wcmluY2lwbGVzJztcbiAqIGNvbnN0IHsgQ29udGFpbmVyIH0gPSBMYXlvdXQ7XG4gKiAqL1xuY29uc3QgUmVsYXRlZENvbnRhaW5lciA9IHByb3BzID0+IDxTdHlsZWRDb250YWluZXIgey4uLnByb3BzfS8+O1xuXG5SZWxhdGVkQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ1JlbGF0ZWRDb250YWluZXInO1xuXG5SZWxhdGVkQ29udGFpbmVyLnByb3BUeXBlcyA9IHtcbiAgY2hpbGRyZW46IFByb3BUeXBlcy5ub2RlLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgUmVsYXRlZENvbnRhaW5lcjtcbiJdfQ== */"));
/** // Container Component
 * import { Layout } from '@kbbcomponentlibrary/principles';
 * const { Container } = Layout;
 * */

var RelatedContainer = function RelatedContainer(props) {
  return _react["default"].createElement(StyledContainer, props);
};

RelatedContainer.displayName = 'RelatedContainer';
RelatedContainer.propTypes = {
  children: _propTypes["default"].node
};
var _default = RelatedContainer;
exports["default"] = _default;
RelatedContainer.__docgenInfo = {
  "description": "// Container Component\nimport { Layout } from '@kbbcomponentlibrary/principles';\nconst { Container } = Layout;",
  "methods": [],
  "displayName": "RelatedContainer",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Layout/RelatedContainer.js"] = {
    name: "RelatedContainer",
    docgenInfo: RelatedContainer.__docgenInfo,
    path: "src/Layout/RelatedContainer.js"
  };
}